export default "__VITE_ASSET__5LVF3BQH__"